import { useMemo } from 'react';

import useGetLinkedAccountsQuery from '@/modules/user/components/UserDrodpdown/components/OrphanModeSwitcher/queries/useGetLinkedAccounts.query';
import useEmployeeStore from '@/modules/user/stores/useEmployee.store';

const useIsDisplayCompleteRegistrationBanner = () => {
  const { employee } = useEmployeeStore();
  const { formattedData } = useGetLinkedAccountsQuery();

  return useMemo(() => {
    const currentLinkedAccount = formattedData?.find(
      (linkedAccount) => linkedAccount?.employeeId === employee?.id
    );
    return Boolean(currentLinkedAccount?.completeRegistrationAvailable);
  }, [formattedData, employee?.id]);
};

export default useIsDisplayCompleteRegistrationBanner;
